export default __webpack_public_path__ + "static/media/Rectangle-1655-Tata.af386eb8.png";